import { useState } from 'react';
import { Box, Button, Dialog, Typography, TextField } from '@mui/material';
import { CloseIcon } from '../../assets/icons/icons';
import SatisfactionScale from './SatisfactionScale';

export default function CSATModal({ open, onClose, onSubmit, initialRating = 0 }) {
  const [rating, setRating] = useState(initialRating);
  const [comment, setComment] = useState('');

  const handleSubmit = () => {
    onSubmit({ rating, comment: comment || null });
    setRating(0);
    setComment('');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="csat-modal-title"
      maxWidth="lg"
      sx={{ '& .MuiPaper-root': { borderRadius: '12px' } }}
    >
      <Box py={2} px={3} display="flex" flexDirection="column">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography id="csat-modal-title" fontWeight={600} fontSize="1.25rem">
            SVCE eHub Satisfaction Survey
          </Typography>
          <Button
            onClick={onClose}
            sx={{ minWidth: 'auto', p: 0.5 }}
            aria-label="Close survey modal"
          >
            <CloseIcon />
          </Button>
        </Box>

        <Box sx={{ borderTop: 1, borderColor: 'grey.200', pt: 2, mb: 2 }}>
          <Typography mb={1.5}>
            What is your overall satisfaction with SVCE eHub?
          </Typography>
          <SatisfactionScale value={rating} onChange={setRating} />
        </Box>

        <Box sx={{ borderTop: 1, borderColor: 'grey.200', pt: 2 }}>
          <Typography mb={1}>
            Thank you for your input! Please provide any additional feedback below.
          </Typography>
          <TextField
            multiline
            rows={3}
            fullWidth
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            variant="outlined"
            size="small"
          />
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            onClick={handleSubmit}
            disabled={rating === 0}
            sx={{ color: 'primary.main', fontWeight: 600, textTransform: 'uppercase' }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
